module.exports = __webpack_public_path__ + "static/media/microscope.1c9b60a6.jpg";